import { render, staticRenderFns } from "./componentsDoc.vue?vue&type=template&id=27fd767f&scoped=true"
import script from "./componentsDoc.vue?vue&type=script&lang=js"
export * from "./componentsDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd767f",
  null
  
)

export default component.exports